import CityPageTemplate from "../city-template/CityPageTemplate";
import { silverSpringConfig } from "./data";

export default function SilverSpringPage() {
  return <CityPageTemplate config={silverSpringConfig} />;
}